var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bx-calendar-week",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.632,
    height: 19.591,
    viewBox: "0 0 17.632 19.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7466",
    "data-name": "Path 7466",
    d: "M20.173,4.959H17.234V3H15.275V4.959H11.357V3H9.4V4.959H6.459A1.961,1.961,0,0,0,4.5,6.918V20.632a1.961,1.961,0,0,0,1.959,1.959H20.173a1.961,1.961,0,0,0,1.959-1.959V6.918A1.961,1.961,0,0,0,20.173,4.959ZM6.459,20.632V7.9H20.173v-.98l0,13.714Z",
    transform: "translate(-4.5 -3)",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7467",
    "data-name": "Path 7467",
    d: "M10.5,14.48v1.959h9.8V13.5H10.5Z",
    transform: "translate(-6.582 -6.643)",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderWeek);
export default __webpack_public_path__ + "static/media/calender-week.41909e3cbd92d38d6e3d79a950ee88f2.svg";
export { ForwardRef as ReactComponent };